import { render, staticRenderFns } from "./FeatureAssign.vue?vue&type=template&id=6cd840d3&scoped=true&lang=pug&"
import script from "./FeatureAssign.vue?vue&type=script&lang=js&"
export * from "./FeatureAssign.vue?vue&type=script&lang=js&"
import style0 from "./FeatureAssign.vue?vue&type=style&index=0&id=6cd840d3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd840d3",
  null
  
)

export default component.exports